"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
require("../../styles/components/_card.scss");
var Card = /** @class */function (_super) {
  __extends(Card, _super);
  function Card() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.renderTags = function (tags) {
      return tags.split(', ').map(function (tag) {
        return react_1.default.createElement("div", {
          key: tag,
          className: 'tag is-link is-light control'
        }, tag);
      });
    };
    return _this;
  }
  Card.prototype.render = function () {
    var _a = this.props,
      key = _a.key,
      headline = _a.headline,
      title = _a.title,
      leftSubtitle = _a.leftSubtitle,
      rightSubtitle = _a.rightSubtitle,
      tags = _a.tags,
      children = _a.children;
    return react_1.default.createElement("div", {
      className: 'tile is-4 is-parent',
      key: key
    }, react_1.default.createElement("div", {
      className: 'card is-flex is-flex-column'
    }, react_1.default.createElement("div", {
      className: 'card-content is-flex is-flex-column'
    }, react_1.default.createElement("div", {
      className: 'title is-4 has-text-left'
    }, headline), react_1.default.createElement("div", {
      className: 'subtitle is-6'
    }, react_1.default.createElement("small", {
      className: 'is-pulled-left'
    }, leftSubtitle), react_1.default.createElement("small", {
      className: 'is-pulled-right'
    }, rightSubtitle)), react_1.default.createElement("div", {
      className: 'subtitle is-6'
    }, react_1.default.createElement("small", {
      className: 'is-pulled-left has-text-weight-semibold'
    }, title)), react_1.default.createElement("div", {
      className: 'content has-text-left'
    }, children), react_1.default.createElement("div", {
      className: 'card-tags control'
    }, tags && this.renderTags(tags)))));
  };
  return Card;
}(react_1.PureComponent);
exports.default = Card;